import React from 'react';
import DatePicker from 'react-datepicker';
import {
    DATE_FNS_DATE_DISPLAY_FORMAT,
    C_TIMELINE_MIN_DATE,
    C_TIMELINE_MAX_DATE,
    E_TIME_PRESET_KEYS,
} from '../../constants';
import { map } from 'lodash/fp';
import cx from 'classnames';

interface Props {
    startDate?: Date;
    onChangeStartDate: (startDate: Date) => void;
    onChangeTimeSpan: (timeSpan: E_TIME_PRESET_KEYS) => void;
    timespanPresets: E_TIME_PRESET_KEYS[];
    timespan?: E_TIME_PRESET_KEYS;
    filterDate?: (date: Date)=> boolean;
    maxDate?: Date | null;
    minDate?: Date | null;
    popperPlacement?: any;
    dropdownDateFormat?: string;
    placement?: Placement;
}

//todo: refactor with similar type
type Placement = 'top' | 'bottom';

const GQDatePicker = React.memo(
    ({
        onChangeStartDate,
        onChangeTimeSpan,
        timespanPresets,
        startDate,
        timespan,
        filterDate,
        minDate,
        maxDate,
        popperPlacement, //todo: remove
        placement = 'bottom',
    }: Props) => {
        return (
            <div className="top-nav-date-picker" data-testid="date-picker">
                <div className="top-nav-date">
                    <div className={cx('date-range-picker-wrapper', placement)}>
                        <div className="date-range-presets-wrapper">
                            <div className="date-range-presets">
                                {map(currTimeSpan => {
                                    return (
                                        <span
                                            data-testid="date-preset"
                                            className={`time-preset ${
                                                timespan === currTimeSpan
                                                    ? 'selected'
                                                    : ''
                                            }`}
                                            key={currTimeSpan}
                                            onClick={() =>
                                                onChangeTimeSpan(currTimeSpan)
                                            }>
                                            {currTimeSpan}
                                        </span>
                                    );
                                }, timespanPresets)}
                            </div>
                        </div>
                        <div className="calendars-wrapper">
                            <DatePicker
                                calendarClassName="start-date-picker datepicker-single"
                                inline
                                onChange={onChangeStartDate}
                                selected={startDate}
                                selectsStart
                                startDate={startDate}
                                maxDate={
                                    maxDate || C_TIMELINE_MAX_DATE.toDate()
                                }
                                minDate={
                                    minDate || C_TIMELINE_MIN_DATE.toDate()
                                }
                                dateFormat={DATE_FNS_DATE_DISPLAY_FORMAT}
                                showYearDropdown
                                showMonthDropdown
                                peekNextMonth={false}
                                filterDate={filterDate}
                                popperPlacement={popperPlacement}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

export default GQDatePicker;